import React from 'react';
export function Footer() {
  return <footer className="w-full bg-slate-900 px-8 py-14 text-stone-50 sm:px-14" data-id="element-119" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-6xl" data-id="element-120" data-mp="3ggaqfufcyb4x">
        <p className="font-serif text-3xl tracking-tight" data-id="element-121" data-mp="3ghc0pwojutll">
          GYMKLAR<span className="align-super text-[0.5em]" data-id="element-122" data-mp="32p5lcct80qn7">™</span>
        </p>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-stone-50/60" data-id="element-123" data-mp="36oxw8w6378vq">
          GYMKLAR™ er et selvstendig undervisningsmateriell for kroppsøving og ikke et offisielt produkt fra Utdanningsdirektoratet.
        </p>
        <p className="mt-10 border-t border-white/10 pt-6 text-xs text-stone-50/60" data-id="element-124" data-mp="37fu95czww38">
          © 2026 GYMKLAR™ · Edulabs Resources
        </p>
      </div>
    </footer>;
}